import { usePage } from "PFApp/use_page";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";

export const useNewUSerPage = (initPage) => {
  const { page, setPage, mergePage, resetPage } = usePage(`new_user`, initPage);

  const { data: currentProfile } = useCurrentProfile();

  const fetchPermissionsGroups = () =>
    $.ajax({
      url: ApiRoute(`/api/admin/permissions_groups`),
      api_version: 2
    })
      .then((response) => {
        mergePage({
          permissionsGroups: response.entries,
          loaded: true
        });
      })
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    if (!currentProfile.id) {
      return;
    }

    fetchPermissionsGroups();
  }, [currentProfile.id]);

  return { ...page };
};
